<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let extraStyles = "height: 100%; width: 80px;";
  export let extraClassNames = "fizz-icon-logo fizz-text-brand";
  export let extraContainerClass = "";
</script>

<style>
  .provi-logo {
    width: 76px;
    height: 38px;
  }

  @media (max-width: 700px) {
    .provi-logo {
      width: 48px;
      height: 24px;
    }
  }
</style>

<a id="logo" class="provi-logo {extraContainerClass}" href="/">
  <Icon type="ProviLogo" {extraStyles} {extraClassNames} />
</a>
